import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import Login from './pages/Login'

const AuthWrapper = ({ children, token }) => {
  return token ? children : <Redirect to={'/login'} />
}

export default withRouter(connect(
  ({ auth }) => ({
    token: auth.access_token
  })
)(AuthWrapper));



// WEBPACK FOOTER //
// ./src/components/AuthWrapper.js